<div class="d-flex align-items-center">
    <span style="font-size: 2rem" [innerHTML]="translationService.getTranslation('after_complaint')"> </span>
</div>
